module.exports = __webpack_public_path__ + "static/img/catalog_distributor.6c95a46c.png";